<script setup lang="ts">
import { useData } from 'vike-vue/useData'
import type { ParentHomeData } from './+data'

const data = useData<ParentHomeData>()
</script>

<template>
  <div v-if="data">
    <CommonPagesHomePage
      v-if="data.homepage"
      :data="data"
    />
    <CommonPagesProductHub
      v-else-if="data.productHub"
      :data="data"
      :display-breadcrumb="false"
    />
    <CommonPagesProduct
      v-else-if="data.product"
      :data="data"
      :display-breadcrumb="false"
    />
    <CommonPagesMyself
      v-else-if="data.myself"
      :data="data"
      :display-breadcrumb="false"
    />
  </div>
</template>
